import {
  GridItem,
  NumericReadOnlyField,
  ReadOnlyField,
  ReadOnlyTextarea,
  SimpleGrid,
} from '@agrotoken-tech/ui';
import { formatDate } from '@bcba/common-utils';
import { useTranslation } from '@bcba/react-hooks';
import { useCropPledgeInformationContext } from '../../context/CropPledgeInformationContext';

const PledgeInformationForm = () => {
  const { t } = useTranslation();
  const { data } = useCropPledgeInformationContext();
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} mt="6" spacing={6}>
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.celebrationProvince.label')}
        value={
          data?.celebrationProvince?.name ?? t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.celebratedAt.label')}
        value={
          data?.celebratedAt
            ? formatDate(data.celebratedAt)
            : t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.pledgeClass.label')}
        value={
          data?.pledgeClass
            ? t(`pledgeClass.${data.pledgeClass}`)
            : t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.degree.label')}
        value={
          data?.degree
            ? t(`pledgeDegree.${data.degree}`)
            : t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.currency.label')}
        value={
          data?.currencyType
            ? t(`currency.${data.currencyType}`)
            : t('common.toBeCompletedByBolsa')
        }
      />
      <NumericReadOnlyField
        label={t('cropPledge.pledgeInformation.form.contractAmount.label')}
        value={
          data?.contractAmount?.toString() ?? t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t(
          'cropPledge.pledgeInformation.form.contractAmountInText.label',
        )}
        value={data?.contractAmountInText ?? t('common.toBeCompletedByBolsa')}
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.exchangeRate.label')}
        value={
          data?.exchangeRate?.toString() ?? t('common.toBeCompletedByBolsa')
        }
      />
      <NumericReadOnlyField
        label={t('cropPledge.pledgeInformation.form.amountInPesos.label')}
        value={
          data?.amountInPesos?.toString() ?? t('common.toBeCompletedByBolsa')
        }
        helperText={t(
          'cropPledge.pledgeInformation.form.amountInPesos.helperText',
        )}
      />
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <ReadOnlyTextarea
          label={t('cropPledge.pledgeInformation.form.obligationConcept.label')}
          value={data?.obligationConcept ?? t('common.toBeCompletedByBolsa')}
        />
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <ReadOnlyTextarea
          label={t('cropPledge.pledgeInformation.form.documentation.label')}
          value={data?.documentation ?? t('common.toBeCompletedByBolsa')}
        />
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <ReadOnlyTextarea
          label={t(
            'cropPledge.pledgeInformation.form.paymentMethodsAndTerms.label',
          )}
          value={
            data?.paymentMethodsAndTerms ?? t('common.toBeCompletedByBolsa')
          }
        />
      </GridItem>
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.annualInterestRate.label')}
        value={
          data?.annualInterestRate?.toString() ??
          t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.paymentProvince.label')}
        value={data?.paymentProvince?.name ?? t('common.toBeCompletedByBolsa')}
      />
      <ReadOnlyField
        label={t(
          'cropPledge.pledgeInformation.form.creditorInspectionRights.label',
        )}
        value={
          data?.creditorInspectionRights
            ? t(`creditorInspectionRights.${data.creditorInspectionRights}`)
            : t('common.toBeCompletedByBolsa')
        }
      />
      <ReadOnlyField
        label={t('cropPledge.pledgeInformation.form.liens.label')}
        value={data?.liens ?? t('common.toBeCompletedByBolsa')}
      />
    </SimpleGrid>
  );
};

export default PledgeInformationForm;
